import { useRecordContext } from "react-admin";

export const hasActiveThriveeCertification = (record) => {
  if (!record?.certificates || !Array.isArray(record.certificates)) {
    return false;
  }
  return record.certificates.some(
    cert => cert?.valid === true && cert?.type === 'THRIVE_KNOWLEDGE_QUIZ'
  );
};

export const getActiveCertification = (record) => {
  if (!record?.certificates || !Array.isArray(record.certificates)) {
    return null;
  }
  return record.certificates.find(
    cert => cert?.valid === true && cert?.type === 'THRIVE_KNOWLEDGE_QUIZ'
  );
};

export const CertificationField = (props) => {
  const record = useRecordContext();
  const isActive = hasActiveThriveeCertification(record);
  
  return <span>{isActive ? "Yes" : "No"}</span>;
};

export const CertificationShowField = (props) => {
  const record = useRecordContext();
  const cert = getActiveCertification(record);

  if (!cert) {
    return <span>No active certification</span>;
  }

  const expiryDate = cert.expiresAt 
    ? new Date(cert.expiresAt).toLocaleDateString()
    : "—";

  return (
    <div>
      <div><strong>Status:</strong> Active ✓</div>
      <div><strong>Type:</strong> {cert.type}</div>
      <div><strong>Expires:</strong> {expiryDate}</div>
    </div>
  );
};
